import baseAPI from '@/api/base';
import { EditEmployeeEducation, GetEmployeeEducation, RegisterEmployeeEducation } from '@/dtos/employee_education.dto';
import {
  DELETE_EMPLOYEE_EDUCATION_URL,
  EDIT_EMPLOYEE_EDUCATION_URL,
  GET_EMPLOYEE_EDUCATION_URL,
  REGISTER_EMPLOYEE_EDUCATION_URL,
  TOGGLE_EMPLOYEE_EDUCATION_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class EmployeeEducation {
  static getEmployeeEducations = async (getEmployeeEducation: GetEmployeeEducation): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_EMPLOYEE_EDUCATION_URL, {
      params: getEmployeeEducation,
    });
    console.log('response', response);
    return response;
  };

  static registerEmployeeEducation = async (
    registerEmployeeEducation: RegisterEmployeeEducation
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_EMPLOYEE_EDUCATION_URL, {
      ...registerEmployeeEducation,
    });
    console.log('response', response);
    return response;
  };

  static editEmployeeEducation = async (editEmployeeEducation: EditEmployeeEducation): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_EMPLOYEE_EDUCATION_URL, {
      ...editEmployeeEducation,
    });
    return response;
  };

  static toggleEmployeeEducationIsActive = async (
    editEmployeeEducation: EditEmployeeEducation
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_EMPLOYEE_EDUCATION_IS_ACTIVE_URL,
      {
        ...editEmployeeEducation,
      }
    );
    return response;
  };

  static deleteEmployeeEducation = async (userId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_EMPLOYEE_EDUCATION_URL}/${userId}`
    );
    return response;
  };
}

export default EmployeeEducation;
